import { createContext, useContext } from 'react';
import type { tLeadAgentAcceptanceContext } from './LeadAgentAcceptance.types';

const DEFAULT_LEAD_AGENT_ACCEPTANCE_CONTEXT: tLeadAgentAcceptanceContext = {
  acceptance: null,
  isLoadingAcceptance: false,
  isAcceptanceSettled: true,
  isBannerVisible: false,
  daysUntilPayment: null,
  bannerVariant: 'informative',
  daysSincePayment: null,
  expiredPhase: null,
  isExpiredForOwner: false,
  isReactivateEntryVisibleForOwner: false,
  isExpiredForAdmin: false,
  hasNoLeadAgentAccess: false,
  everUsed: null,
  isPausedWithinTrialForOwner: false,
  isPausedAndLapsedForOwner: false,
  isPausedForOwner: false,
  isPausedRow: false,
  isRevokedRow: false,
  isRevokedForOwner: false,
  isTrialActivatableForOwner: false,
  isTrialActivatableForAdmin: false,
  isNearLimitForOwner: false,
  isNearLimitForAdmin: false,
  isCappedForOwner: false,
  isCappedForAdmin: false,
  usageCapacityPct: null,
  usageResetDate: null,
  usageTier: null,
  paidUsageBand: null,
  activeTierForOwner: null,
  isTrialSightingForOwner: false,
  isTrialSightingForAdmin: false,
  isTrialCappedForOwner: false,
  isTrialCappedForAdmin: false,
  isTrialExtendedCappedForOwner: false,
  isTrialExtendedCappedForAdmin: false,
  trialCapOffer: null,
  trialCapDaysUntilTrialEnd: null,
  usageReadStatus: 'idle',
  unlockOfferReadStatus: 'idle',
  usageIsTrialCap: false,
  retryTrialCapReads: () => {},
  dismissedAt: null,
  acceptTier: async () => {
    throw new Error('LeadAgentAcceptanceProvider is not mounted');
  },
  pauseAcceptance: async () => {
    throw new Error('LeadAgentAcceptanceProvider is not mounted');
  },
  refreshAcceptance: async () => {
    throw new Error('LeadAgentAcceptanceProvider is not mounted');
  },
  markResolved: () => {},
  settleTrialCapUnlock: () => {},
  hasUnlockedTrialCapThisSession: false,
  dismissExpired: async () => {
    throw new Error('LeadAgentAcceptanceProvider is not mounted');
  },
};

export const LeadAgentAcceptanceContext =
  createContext<tLeadAgentAcceptanceContext>(
    DEFAULT_LEAD_AGENT_ACCEPTANCE_CONTEXT,
  );

export function useLeadAgentAcceptanceContext(): tLeadAgentAcceptanceContext {
  return useContext(LeadAgentAcceptanceContext);
}
